<div class="space-y-6">
  @for (group of checklist().groups; track group.id || group.title) {
    <div class="space-y-4 border border-border-secondary rounded-[20px] p-6">
      <h4>{{ group.title }}</h4>

      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        @for (item of group.items; track item.id || item.content) {
          <div class="flex flex-col gap-3">
            @if (item.imageUrl) {
              <img
                [src]="item.imageUrl"
                [alt]="item.content"
                class="h-20 w-20 rounded-lg object-cover border border-border-secondary flex-shrink-0" />
            } @else {
              <div
                class="h-20 w-20 rounded-lg border border-border-secondary flex items-center justify-center flex-shrink-0 bg-gray-50">
                <ui-icon icon="griddy-image" class="text-gray-400" />
              </div>
            }

            @if (item.status) {
              <ui-badge [value]="item.status" appearance="subtle" variant="gray" />
            }

            <div>{{ item.content }}</div>
          </div>
        }
      </div>
    </div>
  }
</div>
